import * as t from "io-ts";
import { Audit } from "./Audit";
import { Company } from "./Company";
import { Credit } from "./Credit";
import { Enquiry } from "./Enquiry";
import { Enterprise } from "./Enterprise";
import { Introduction } from "./Introduction";
import { Job } from "./Job";
import { Onboarding } from "./Onboarding";
import { Tag } from "./Tag";
import { Transaction } from "./Transaction";

export const SearchHits = t.type({
  audit: t.array(Audit),
  audit_hits: t.number,
  audit_returned: t.number,
  company: t.array(Company),
  company_hits: t.number,
  company_returned: t.number,
  credit: t.array(Credit),
  credit_hits: t.number,
  credit_returned: t.number,
  enquiry: t.array(Enquiry),
  enquiry_hits: t.number,
  enquiry_returned: t.number,
  enterprise: t.array(Enterprise),
  enterprise_hits: t.number,
  enterprise_returned: t.number,
  introduction: t.array(Introduction),
  introduction_hits: t.number,
  introduction_returned: t.number,
  job: t.array(Job),
  job_hits: t.number,
  job_returned: t.number,
  onboarding: t.array(Onboarding),
  onboarding_hits: t.number,
  onboarding_returned: t.number,
  tag: t.array(Tag),
  tag_hits: t.number,
  tag_returned: t.number,
  transaction: t.array(Transaction),
  transaction_hits: t.number,
  transaction_returned: t.number,
});

export interface SearchHits {
  audit: Array<Audit>;
  audit_hits: number;
  audit_returned: number;
  company: Array<Company>;
  company_hits: number;
  company_returned: number;
  credit: Array<Credit>;
  credit_hits: number;
  credit_returned: number;
  enquiry: Array<Enquiry>;
  enquiry_hits: number;
  enquiry_returned: number;
  enterprise: Array<Enterprise>;
  enterprise_hits: number;
  enterprise_returned: number;
  introduction: Array<Introduction>;
  introduction_hits: number;
  introduction_returned: number;
  job: Array<Job>;
  job_hits: number;
  job_returned: number;
  onboarding: Array<Onboarding>;
  onboarding_hits: number;
  onboarding_returned: number;
  tag: Array<Tag>;
  tag_hits: number;
  tag_returned: number;
  transaction: Array<Transaction>;
  transaction_hits: number;
  transaction_returned: number;
}
